<template>
  <div class="main-div">
    <section id="container" class="gnb_pdt">
      <div class="title_wrap">
        <h1 class="f_l">수령 관리</h1>
          <button v-if="!isProd && isSU" class="mid_btn" @click="setDemoData" >
            <span>시연용</span>
          </button>
        <div style="text-align:right; font-size:23px; float:right; line-height: 42px;">
        <button class="large_btn orange" style="width:100px; float:right; margin-left:10px;"
                @click="onClickRefresh"
        > 새로고침
        </button> {{ lastRenderingTime }}
        <kendo-switch
            ref="autoYnRef"
            :messages-checked="'자동'"
            :messages-unchecked="'수동'"
            :checked="autoRender"
            @change="setAutoRender"
        >
        </kendo-switch>
        </div>
      </div>
      <!--  검색 창  -->
      <div class="contents_wrap mg0">
        <div class="content_list">
          <div class="button_wrap_area">
            <ul>
              <li>
                <button class="large_btn orange" @click="commonOnChangeEvent">검색</button>
              </li>
              <li>
                <button class="large_btn" @click="cleanFilter">초기화</button>
              </li>
            </ul>
          </div>
          <div id="filter_section" class="filter_wrap">
            <ul class="filter_list">
              <li class="col3">
                <dd>
                  <label>사업장</label>
                  <ul>
                    <li>
                      <kendo-dropdownlist
                        class="w100"
                        ref="facilityRef"
                        :data-source="zone1DepthList"
                        :value="lastRouteParams.facility"
                        :data-text-field="'cdNm'"
                        :data-value-field="'cdId'"
                        :option-label="'전체'"
                        :no-data-template="'표시할 데이터가 없습니다.'"
                        @change="onChangeFacility"
                      >
                      </kendo-dropdownlist>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>거점</label>
                  <ul>
                    <li>
                      <kendo-dropdownlist
                          class="w100"
                          ref="areaRef"
                          :data-source="zone2DepthList"
                          :value="lastRouteParams.area"
                          :data-text-field="'cdNm'"
                          :data-value-field="'cdId'"
                          :option-label="'전체'"
                          :no-data-template="'표시할 데이터가 없습니다.'"
                          @change="commonOnChangeEvent"
                      >
                      </kendo-dropdownlist>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>특송사</label>
                  <ul>
                    <li>
                      <kendo-dropdownlist
                          class="w100"
                          ref="shpcScnRef"
                          :data-source="receiveShpcScnList"
                          :value="lastRouteParams.shpcScn"
                          :data-text-field="'cdNm'"
                          :data-value-field="'cdId'"
                          :option-label="'전체'"
                          :no-data-template="'표시할 데이터가 없습니다.'"
                          @change="commonOnChangeEvent"
                      >
                      </kendo-dropdownlist>
                    </li>
                  </ul>
                </dd>

              </li>
              <li class="col3">
                <dd>
                  <label>입고일</label>
                  <ul>
                    <li>
                      <div class="fl k-widget k-daterangepicker k-state-default"
                           data-role="daterangepicker"
                           role="combobox"
                           aria-expanded="false"
                           autocomplete="off">
                        <kendo-datepicker
                            ref="incDtStartDtRef"
                            :max="maxDate"
                            :value="lastRouteParams.incDtStartDt"
                            :placeholder="'년/월/일'"
                            :format="'yyyy/MM/dd'"
                            @change="commonOnChangeEvent">
                        </kendo-datepicker>
                        <span>&nbsp;</span>
                        <kendo-datepicker
                            ref="incDtEndDtRef"
                            :max="maxDate"
                            :value="lastRouteParams.incDtEndDt"
                            :placeholder="'년/월/일'"
                            :format="'yyyy/MM/dd'"
                            @change="commonOnChangeEvent">
                        </kendo-datepicker>
                      </div>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>발신</label>
                  <ul>
                    <li>
                      <kendo-maskedtextbox
                          class="w100"
                          ref="sendNmRef"
                          :placeholder="'발신처 입력'"
                          :value="lastRouteParams.sendNm"
                          id="sendNm"
                      >
                      </kendo-maskedtextbox>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>취급 구분</label>
                  <ul>
                    <li>
                      <kendo-dropdownlist
                          class="w100"
                          ref="receiveScnRef"
                          :data-source="receiveScnList"
                          :value="lastRouteParams.receiveScn"
                          :data-text-field="'cdNm'"
                          :data-value-field="'cdId'"
                          :option-label="'전체'"
                          :no-data-template="'표시할 데이터가 없습니다.'"
                          @change="commonOnChangeEvent"
                      >
                      </kendo-dropdownlist>
                    </li>
                  </ul>
                </dd>
              </li>
              <li class="col3">
                <dd>
                  <label>완료일</label>
                  <ul>
                    <li>
                      <div class="fl k-widget k-daterangepicker k-state-default"
                           data-role="daterangepicker"
                           role="combobox"
                           aria-expanded="false"
                           autocomplete="off">
                        <kendo-datepicker
                            ref="endDtStartDtRef"
                            :max="maxDate"
                            :value="lastRouteParams.endDtStartDt"
                            :placeholder="'년/월/일'"
                            :format="'yyyy/MM/dd'"
                            @change="commonOnChangeEvent">
                        </kendo-datepicker>
                        <span>&nbsp;</span>
                        <kendo-datepicker
                            ref="endDtEndDtRef"
                            :max="maxDate"
                            :value="lastRouteParams.endDtEndDt"
                            :placeholder="'년/월/일'"
                            :format="'yyyy/MM/dd'"
                            @change="commonOnChangeEvent">
                        </kendo-datepicker>
                      </div>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>수신</label>
                  <ul>
                    <li>
                      <kendo-maskedtextbox
                          class="w100"
                          ref="receiveNmRef"
                          :placeholder="'수신/수령/사번 입력'"
                          id="receiveNm"
                          :value="lastRouteParams.receiveNm"
                      >
                      </kendo-maskedtextbox>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>운송장 번호</label>
                  <ul>
                    <li>
                      <kendo-maskedtextbox
                          class="w100"
                          ref="blNoRef"
                          :placeholder="'송장 번호 입력'"
                          :value="lastRouteParams.blNo"
                          id="blNo"
                      >
                      </kendo-maskedtextbox>
                    </li>
                  </ul>
                </dd>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!--  진행 상태 탭  -->
      <ul class="tab mgt30">
        <li v-for="item in [{cdNm:'전체', cdId: undefined}, ...receiveStatusList]"
            :class="{on : (lastRouteParams.status === item.cdId)}"
            @click="$set(lastRouteParams, 'status', item.cdId); commonOnChangeEvent()">
          {{ item.cdNm }}
        </li>
      </ul>
      <!--  버튼 영역  -->
      <div class="dblock mgt20">
        <div class="c_t_button_wrap f_l">
          <button class="mid_btn orange mr5" @click="onClickReceiveSave"><span><span class="k-icon k-i-plus"></span>수령 등록</span></button>
          <button class="mid_btn" @click="onClickBatchUpdate(null)" :disabled="!(lastRouteParams.status === '02' || lastRouteParams.status === undefined)" ><span>일괄 전달 완료</span></button>
        </div>
        <div class="c_t_button_wrap f_r">
          <button v-if="isSU" class="mid_btn mr5" @click="onClickExcelUpload" ><i class="download_icon"></i><span>엑셀 업로드</span></button>
          <button class="mid_btn" @click="onClickExcelDownload"><i class="download_icon"></i><span>엑셀 다운로드</span></button>
        </div>
      </div>
      <!--  리스트 영역 -->
      <kendo-grid ref="receiveListGridRef"
                  id="grid"
                  class="basic_table mgt10"
                  :columns="receiveListColumns"
                  :data-source="receiveDataSource"
                  :dataBound="onDataBoundForCommand"
                  @change="onChangeEventGrid"
                  :navigatable="true"
                  :filterable="false"
                  :sortable="true"
                  :scrollable="true"
                  :pageable-always-visible="true"
                  :pageable-page-sizes="[5, 10, 20, 50, 100, 500, 1000]"
                  :reorderable="true"
                  :column-menu="false"
                  :resizable="true"
                  :selectable="'multiple row'"
                  :noRecords="{ template: '<div class=\'gridNoData\' style=\'text-align: center;\'>표시할 데이터가 없습니다.</div>' }">
      </kendo-grid>
      <receive-excel-upload-window
          ref="receiveExcelUploadWindowRef"
          @onChange="commonOnChangeEvent"
      >
      </receive-excel-upload-window>
      <!--  추가 정보 입력 창  -->
      <create-stead-receive
          ref="createSteadReceiveWindowRef"
          @getUserData="steadReceiveSave"
      ></create-stead-receive>
      <create-stead-receive-inter-docu
          ref="createSteadReceiveInterDocuWindowRef"
          @getUserData="steadReceiveSave"
      ></create-stead-receive-inter-docu>
      <create-my-receive-inter-docu
          ref="createMyReceiveInterDocuWindowRef"
          @getUserData="myReceiveSave"
      ></create-my-receive-inter-docu>
    </section>
  </div>
</template>
<script>
import ApiConfig from "@/api/api.config";
import EtnersDateTimeUtil from "@/common/etners.datetime.util";
import EtnersParseUtil from "@/common/etners.parse.util";
import $ from "jquery";
import ApiUtil from "@/api/api.util";
import EtnersCommonUtil from "@/common/etners.common.util";
import {saveExcel} from "@progress/kendo-vue-excel-export";
import receiveExcelUploadWindow from '@/components/receive/receiveExcelUploadWindow.vue'

import {LogisticsCodeDtlMixin, ZoneMixin} from "@/mixin/Mixin";
import CreateSteadReceiveInterDocu from '@/components/receive/CreateSteadReceiveInterDocu.vue'
import CreateSteadReceive from '@/components/receive/CreateSteadReceive.vue'
import CreateMyReceiveInterDocu from '@/components/receive/CreateMyReceiveInterDocu.vue'
import Apiconfig from '@/api/api.config'

export default {
  name: "ReceiveList",
  components: {
    CreateMyReceiveInterDocu,
    CreateSteadReceive,
    CreateSteadReceiveInterDocu,
    receiveExcelUploadWindow
  },
  mixins: [LogisticsCodeDtlMixin, ZoneMixin],
  created() {},
  beforeMount(){
    const vm = this
    const jsonStrLastRouteParams = sessionStorage.getItem('LAST_ROUTE_PARAMS')
    vm.lastRouteParams = sessionStorage.getItem('LAST_ROUTE_NAME') === 'ReceiveDetail' ? (jsonStrLastRouteParams === undefined ? [] : JSON.parse(jsonStrLastRouteParams)) : []
  },
  mounted() {
    const vm = this
    // 그리드 데이터
    vm.settingDefault()
    vm.$refs.incDtEndDtRef.kendoWidget().value(vm.maxDate)

    //엔터키 이벤트 자동 세팅
    const enterkeyEventTargetIdArray = [
      'receiveNm', 'blNo', 'sendNm'
    ]

    for (const elementId of enterkeyEventTargetIdArray) {
      const element = document.getElementById(elementId)
      if (element !== undefined) {
        element.onkeyup = function (e) {
          const ENTER_KEY_CODE = 'Enter'
          const NUM_PAD_ENTER = 'NumpadEnter'
          const currentKeyCode = e.code

          if (currentKeyCode === ENTER_KEY_CODE || currentKeyCode === NUM_PAD_ENTER) {
            vm.commonOnChangeEvent(e)
          }
        }
      }
    }
  },
  methods : {
    // 자동 새로고침
    setAutoRender () {
      const vm = this
      vm.autoRender = !vm.autoRender
      if(vm.autoRender){
        vm.intervalSetting = window.setInterval(() => {
          vm.commonOnChangeEvent()
          vm.lastRenderingTime = EtnersParseUtil.convertDateToStringYYYYMMDDHHMISSFormat(new Date())
            }, 300000
        );
      }else{
        window.clearInterval(vm.intervalSetting);
      }
    },
    // 수령 리스트 API
    getReceiveList () {
      const vm = this
      vm.lastRouteParams = vm.lastRouteParams === null ? {} : vm.lastRouteParams
      const lastRequestParameterPage = vm.lastRouteParams.page !== undefined ? vm.lastRouteParams.page : 1
      const lastRequestParameterPageSize = vm.lastRouteParams.pageSize !== undefined ? vm.lastRouteParams.pageSize : 10

      vm.receiveDataSource = new kendo.data.DataSource({
        name: 'receiveDataSource',
        page: lastRequestParameterPage,
        pageSize: lastRequestParameterPageSize,
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        transport: {
          read: {
            url: `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/receive/receiveList.json`,
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            cache: false
          },
          parameterMap: function(options, operation) {
            if (operation === 'read') {

              const paramToKendoFilters = vm.currentPageFilterOption()
              const params = {
                loginUserToken: vm.loginUserToken,
                skip: options.skip,
                take: options.take,
                sort: options.sort,
                page: options.page,
                pageSize: options.pageSize,
                facility: paramToKendoFilters.facility,
                area : paramToKendoFilters.area,
                receiveNm : paramToKendoFilters.receiveNm,
                incDtStartDt : paramToKendoFilters.incDtStartDt,
                incDtEndDt : paramToKendoFilters.incDtEndDt,
                blNo : paramToKendoFilters.blNo,
                sendNm : paramToKendoFilters.sendNm,
                status : paramToKendoFilters.status,
                endDtStartDt : paramToKendoFilters.endDtStartDt,
                endDtEndDt : paramToKendoFilters.endDtEndDt,
                receiveScn: paramToKendoFilters.receiveScn,
                shpcScn: paramToKendoFilters.shpcScn,
                requestType : 'PAGING', // PAGING or EXPORT
              }
              sessionStorage.setItem('LAST_ROUTE_PARAMS', kendo.stringify(params))
              return kendo.stringify(params)
            }
            if (operation !== 'read' && options.models) {
              return {models: kendo.stringify(options.models)}
            }
          }
        },
        schema: {
          type: 'json',
          parse: function(response) {
            if (response.resultStatus.messageCode !== '2000') {
              kendo.alert('message: ' + response.resultStatus.messageText)
              return ''
            }
            const changeResultData = response.resultData
            let rowNumber = response.total > 1 ? response.total - ((vm.$refs.receiveListGridRef
                .dataSource.page() - 1) * vm.$refs.receiveListGridRef.dataSource.pageSize()) : response.total
            if (changeResultData === null) {
              return false
            }
            for (let i = 0; i < changeResultData.length; i++) {
              const row = changeResultData[i]
              // row 번호 내림차순 셋팅
              row.rowNumber = rowNumber--
            }
            //status 상태 값 받아오기
            response.resultData = changeResultData
            return response
          },
          total: function(response) {
            return response.total
          },
          data: function(response) {
            // 카테고리 seq 순으로 배열 선언
            if (response.resultStatus.messageCode === '2000') {
              return response.resultData
            } else {
              kendo.alert('message: ' + response.resultStatus.messageText)
              return ''
            }
          }
        },
        error: function(e) {
          // console.log('error event handler', e.errors)
        }
      })
    },
    // facility 에 따른 area 세팅
    onChangeFacility() {
      const vm = this
      vm.onChange1Depth('facilityRef')
      vm.$refs.areaRef.kendoWidget().setDataSource(vm.zone2DepthList)
      vm.$refs.areaRef.kendoWidget().value(vm.lastRouteParams.area)
      vm.commonOnChangeEvent()
    },
    // 조건에 따른 검색
    commonOnChangeEvent () {
      const vm = this
      const gridRefs = this.$refs.receiveListGridRef
      if (gridRefs !== undefined && gridRefs.kendoWidget() !== undefined) {
        if (vm.lastRouteParams.page === undefined) {
          gridRefs.kendoWidget().dataSource.page(1)
        } else {
          gridRefs.kendoWidget().dataSource.read()
          this.lastRouteParams.page = undefined
        }
      }
    },
    // 검색 조건 초기화
    cleanFilter () {
      const vm = this
      const refs = vm.$refs

      // 사업장
      if(refs.facilityRef !== undefined){
        refs.facilityRef.kendoWidget().select(0)
      }
      // 거점
      if(refs.areaRef !== undefined){
        refs.areaRef.kendoWidget().select(0)
      }
      // 수신
      if(refs.receiveNmRef !== undefined){
        refs.receiveNmRef.kendoWidget().value('')
      }
      // 입고일
      if(refs.incDtStartDtRef !== undefined){
        refs.incDtStartDtRef.kendoWidget().value('')
      }
      if(refs.incDtEndDtRef !== undefined){
        refs.incDtEndDtRef.kendoWidget().value('')
      }
      // B/L NO.
      if(refs.blNoRef !== undefined){
        refs.blNoRef.kendoWidget().value('')
      }
      // 발신
      if(refs.sendNmRef !== undefined){
        refs.sendNmRef.kendoWidget().value('')
      }
      // 종결일
      if(refs.endDtStartDtRef !== undefined){
        refs.endDtStartDtRef.kendoWidget().value('')
      }
      if(refs.endDtEndDtRef !== undefined){
        refs.endDtEndDtRef.kendoWidget().value('')
      }
      // 취급구분
      if(refs.receiveScnRef !== undefined){
        refs.receiveScnRef.kendoWidget().select(0)
      }
      // 특송사
      if(refs.shpcScnRef !== undefined){
        refs.shpcScnRef.kendoWidget().select(0)
      }
      // 진행상태
      vm.lastRouteParams.status = undefined

      vm.commonOnChangeEvent()
    },
    // 검색 조건 세팅
    currentPageFilterOption () {
      const vm = this
      const refs = vm.$refs

      const currentSearchDataObj = {}

      // 사업장
      if(refs.facilityRef !== undefined){
        const facility = refs.facilityRef.kendoWidget().value()
        if(facility !== null && facility !== ''){
          currentSearchDataObj.facility = facility
        }
      }
      // 거점
      if(refs.areaRef !== undefined){
        const area = refs.areaRef.kendoWidget().value()
        if(area !== null && area !== ''){
          currentSearchDataObj.area = area
        }
      }
      // 수신
      if(refs.receiveNmRef !== undefined){
        const receiveNm = refs.receiveNmRef.kendoWidget().value()
        if(receiveNm !== null && receiveNm !== ''){
          currentSearchDataObj.receiveNm = receiveNm
        }
      }
      // 입고일
      if(refs.incDtStartDtRef !== undefined){
        const incDtStartDt = refs.incDtStartDtRef.kendoWidget().value()
        if(incDtStartDt !== undefined && incDtStartDt !== '' && incDtStartDt !== null){
          currentSearchDataObj.incDtStartDt = EtnersDateTimeUtil.dateToYYYYMMDDWithPoint(incDtStartDt, '/')
        }
      }
      if(refs.incDtEndDtRef !== undefined){
        const incDtEndDt = refs.incDtEndDtRef.kendoWidget().value()
        if(incDtEndDt !== undefined && incDtEndDt !== '' && incDtEndDt !== null){
          currentSearchDataObj.incDtEndDt = EtnersDateTimeUtil.dateToYYYYMMDDWithPoint(incDtEndDt, '/')
        }
      }
      // B/L NO.
      if(refs.blNoRef !== undefined){
        const blNo = refs.blNoRef.kendoWidget().value()
        if(blNo !== '' && blNo !== null){
          currentSearchDataObj.blNo = blNo
        }
      }
      // 발신
      if(refs.sendNmRef !== undefined){
        const sendNm = refs.sendNmRef.kendoWidget().value()
        if(sendNm !== '' && sendNm !== null){
          currentSearchDataObj.sendNm = sendNm
        }
      }
      // 종결일
      if(refs.endDtStartDtRef !== undefined){
        const endDtStartDt = refs.endDtStartDtRef.kendoWidget().value()
        if(endDtStartDt !== undefined && endDtStartDt !== '' && endDtStartDt !== null){
          currentSearchDataObj.endDtStartDt = EtnersDateTimeUtil.dateToYYYYMMDDWithPoint(endDtStartDt, '/')
        }
      }
      if(refs.endDtEndDtRef !== undefined){
        const endDtEndDt = refs.endDtEndDtRef.kendoWidget().value()
        if(endDtEndDt !== undefined && endDtEndDt !== '' && endDtEndDt !== null){
          currentSearchDataObj.endDtEndDt = EtnersDateTimeUtil.dateToYYYYMMDDWithPoint(endDtEndDt, '/')
        }
      }
      // 취급구분
      if(refs.receiveScnRef !== undefined){
        const receiveScn = refs.receiveScnRef.kendoWidget().value()
        if(receiveScn !== '' && receiveScn !== null){
          currentSearchDataObj.receiveScn = receiveScn
        }
      }
      // 특송사
      if(refs.shpcScnRef !== undefined){
        const shpcScn = refs.shpcScnRef.kendoWidget().value()
        if(shpcScn !== '' && shpcScn !== null){
          currentSearchDataObj.shpcScn = shpcScn
        }
      }

      currentSearchDataObj.status = vm.lastRouteParams.status

      return currentSearchDataObj
    },
    // 일괄 완료 버튼
    onClickBatchUpdate (steadInfo) {
      const vm = this
      const selectedRows = vm.$refs.receiveListGridRef.kendoWidget().select()
      if (selectedRows.length === 0) {
        kendo.alert('전달 완료 대상을 선택해주세요.')
        return
      }
      // 일괄 완료 처리 대상
      const currentStatus = '02'
      let receiveIdList = []
      for (let selectedRowValue of selectedRows) {
        const row = vm.$refs.receiveListGridRef.kendoWidget().dataItem(selectedRowValue)
        if (!vm.isSU && row.facility !== vm.loginUserData.facility) {
          kendo.alert('소속된 사업장의 물품만 상태변경 가능합니다.')
          return
        }
        if (row.status !== currentStatus) {
          kendo.alert('일괄 완료 처리는 접수 신청 상태만 가능합니다.')
          return
        }
        receiveIdList.push(row.receiveId)
      }
      kendo.confirm(`총 ${receiveIdList.length} 건의 데이터를 일괄 처리하시겠습니까?`).done(function () {
        // 일괄 완료 처리 api 호출
        const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/receive/batchUpdateReceive.json`
        const param = {
          loginUserToken: vm.loginUserToken,
          receiveIdList: receiveIdList,
          currentStatus: currentStatus,
        }
        ApiUtil.post(url, param).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            return false
            const resultStatus = response.data.resultStatus
            if (resultStatus.messageCode !== '2000') {
              kendo.alert(resultStatus.messageText)
              return false
            }
          }
          const resultData = response.data.resultData
          kendo.alert(`${resultData.count} 건이 일괄 완료 처리 되었습니다.`)
          vm.commonOnChangeEvent()
        })
      })
    },
    // 엑셀 다운로드 (수령)
    onClickExcelDownload () {
      const lastRequestParameters = JSON.parse(sessionStorage.getItem('LAST_ROUTE_PARAMS'))
      const excelParams = JSON.parse(JSON.stringify(lastRequestParameters))

      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/receive/receiveListForExcel.json`

      ApiUtil.post(url, excelParams).then(response => {
        let changeResultData = response.data.resultData
        if (EtnersCommonUtil.isNotEmpty(changeResultData)) {

          const currentDate = EtnersDateTimeUtil.lookupDateYYYYMMDD()
          const currentYYYYMMDD = EtnersDateTimeUtil.dateToYYYYMMDD(currentDate)

          saveExcel({
            data: changeResultData,
            fileName: `수령관리_${currentYYYYMMDD}.xlsx`,
            columns: [
              {field: 'frstRgstDt', title: '등록일시', width: '100px',},
              {field: 'facilityNm', title: '사업장', width: '100px',},
              {field: 'areaNm', title: '거점', width: '100px',},
              {field: 'shpcScnNm', title: '특송사', width: '100px',},
              {field: 'qty', title: '수량', width: '100px',},
              {field: 'receiveScnNm', title: '취급 구분', width: '100px',},
              {field: 'blNo', title: '운송장 번호.', width: '100px',},
              {field: 'sendNm', title: '발신', width: '100px',},
              {field: 'receiveNm', title: '수신', width: '100px',},
              {field: 'receiveDept', title: '수신 부서', width: '100px',},
              {field: 'steadNm', title: '수령인', width: '100px',},
              {field: 'terrorSignScnNm', title: '상태 여부', width: '100px',},
              {field: 'receiveDt', title: '수령 일시', width: '100px',},
              {field: 'path', title: '접수 경로', width: '100px',},
              {field: 'statusNm', title: '진행 상태', width: '100px',},
              {field: 'frstRgstId', title: '최초 등록자', width: '100px',},
              {field: 'lastMdfyDt', title: '마지막 수정일시', width: '100px',},
              {field: 'lastMdfyId', title: '마지막 수정자', width: '100px',},
            ]
          })
        } else {
          kendo.alert('다운로드 할 자료가 없습니다.')
        }
      })

    },
    // 엑셀 업로드 (수령)
    onClickExcelUpload () {
      const vm = this
      vm.$refs.receiveExcelUploadWindowRef.$refs.kendoWindowRef
        .kendoWidget()
        .center()
        .open()
    },
    // 상세로 이동
    onChangeEventGrid: function(e){
      const vm = this
      if(!([0].includes(e.sender._lastCellIndex))) {
        const selectedRow = e.sender.select()
        const item = e.sender.dataItem(selectedRow)

        const receiveId = item.receiveId
        if (receiveId !== null){
          vm.$router.push({
            name: 'ReceiveDetail',
            params: {
              receiveId : receiveId
            }
          })
        }
      }
    },
    // 수령 등록으로 이동
    onClickReceiveSave: function (){
      const vm = this
      vm.$router.push({
        name:'ReceiveSave'
      })
    },
    // 사업장 거점 기본세팅
    settingDefault(){
      const vm = this
      const facility = vm.loginUserData.facility
      const area = vm.loginUserData.area

      //사업장
      vm.$refs.facilityRef.kendoWidget().value(facility)
      vm.onChange1Depth('facilityRef')
      //거점
      vm.$refs.areaRef.kendoWidget().setDataSource(vm.zone2DepthList)
      vm.$refs.areaRef.kendoWidget().value(area)
      vm.getReceiveList()
    },
    // 새로고침
    onClickRefresh(data) {
      const vm = this
      vm.lastRenderingTime = EtnersParseUtil.convertDateToStringYYYYMMDDHHMISSFormat(
          new Date()
      );
      vm.$emit('refreshAll', true)
      vm.commonOnChangeEvent()
    },
    // 상세정보 불러오기
    getReceiveDetail (receiveId) {
      const vm = this
      const param = {
        loginUserToken: vm.loginUserToken,
        receiveId: receiveId
      }
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/receive/receiveDetail.json`

      return new Promise((resolve, reject) => {
        ApiUtil.post(url, param).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            reject()
          }
          const resultStatus = response.data.resultStatus
          if (resultStatus.messageCode !== '2000') {
            reject()
          }
          vm.receiveInfo = response.data.resultData // props 세팅
          resolve()
        })
      })
    },
    // 본인 수령
    myReceiveSave (userData) {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/receive/receiveMySave.json`
      const params = {
        loginUserToken: vm.loginUserToken,
        receiveId: vm.receiveInfo.receiveId,
        receivePpsScn: userData.receivePpsScn,
        receivePurpose: userData.receivePurpose,
        receivePurposeDesc: userData.receivePurposeDesc,
      }
      kendo.confirm('본인 수령 처리 하시겠습니까?').done(() => {
        ApiUtil.post(url, params).then(response => {
         if (response.data === undefined || response.data.resultStatus === undefined) {
           kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
           return false
         }
         const resultStatus = response.data.resultStatus
         if (resultStatus.messageCode !== '2000') {
           kendo.alert(resultStatus.messageText)
           return false
         }
         kendo.alert('본인 수령이 처리되었습니다.')
         vm.commonOnChangeEvent()
        })
      })
    },
    // 대리 수령
    steadReceiveSave (userData) {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/receive/receiveSteadSave.json`
      const params = {
        loginUserToken: vm.loginUserToken,
        receiveId: vm.receiveInfo.receiveId,
        receiveNm: userData.receiveNm,
        receiveDept: userData.receiveDept,
        receivePpsScn: userData.receivePpsScn,
        receivePurpose: userData.receivePurpose,
        receivePurposeDesc: userData.receivePurposeDesc,
      }
      kendo.confirm('대리 수령 처리하시겠습니까?').done(() => {
        ApiUtil.post(url, params).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            return false
          }
          const resultStatus = response.data.resultStatus
          if (resultStatus.messageCode !== '2000') {
              kendo.alert(resultStatus.messageText)
              return false
          }
        kendo.alert('대리 수령 처리 되었습니다.')
        vm.commonOnChangeEvent()
        })
      })
    },
    // command에서 변수 활용을 위한 데이터 바운드
    onDataBoundForCommand: function (evt) {
      let grid = evt.sender
      let items = evt.sender.items()

      items.each(function () {
        let dataItem = grid.dataItem(this)
        let lockerNm = kendo.jQuery(this).find('span[name=lockerNm]')
        let lockerCellId = kendo.jQuery(this).find('span[name=lockerCellId]')
        let receiveDt = kendo.jQuery(this).find('span[name=receiveDt]')

        kendo.jQuery(lockerNm).text(dataItem.lockerNm)
        kendo.jQuery(lockerCellId).text(EtnersParseUtil.convertEmptyStringToSeparator(dataItem.lockerCellId))
        kendo.jQuery(receiveDt).text(EtnersParseUtil.convertEmptyStringToSeparator(dataItem.receiveDt))
      })
    },
    // 데모 데이터 등록 트리거
    async setDemoData(){
      const vm = this
      const demoDataList = [
        {
          receiveInfo : {
            status: '01',
            blNo: 'ET00000101',
            receiveScn: '08', //택배
            shpcScn: '09', //일양
            facility: '03',
            receiveNm: '손석희',
            area: '0301',
            receiveDept: '기업부설연구소',
            course: '',
            receiveEmail: '',
            executiveYn: 'N',
            receiveTel: '1533-4810',
            secretaryNm: null,
            receiveSabun: '66790619',
            secretaryEmail: null,
            sendNm: '이트너스',
            qty: Number('1'),
            receiveAreaScn: null,
            etcScn: '01',
            terrorSignScn: '01',
            contents: 'DEMO',
            lockerId: '00002', // DSR 무인보관함
            receiveEmailList: [
              "00@etners.com"
            ],
          },
          lockerInfo : {
            lockerCellId: '2023080700001', // 2023080700001, 2023080700002, 2023080700008, 2023080700009
            originId: '1', // 1, 8, 2, 9
          },
        },
        {
          receiveInfo : {
            status: '01',
            blNo: 'ET00000202',
            receiveScn: '07', //EMS
            shpcScn: '08', //우체국
            facility: '03',
            receiveNm: '손석희',
            area: '0301',
            receiveDept: '기업부설연구소',
            course: '',
            receiveEmail: '',
            executiveYn: 'N',
            receiveTel: '1533-4810',
            secretaryNm: null,
            receiveSabun: '66790619',
            secretaryEmail: null,
            sendNm: '이트너스',
            qty: Number('1'),
            receiveAreaScn: null,
            etcScn: '01',
            terrorSignScn: '01',
            contents: 'DEMO',
            lockerId: '00002', // DSR 무인보관함
            receiveEmailList: [
              "00@etners.com"
            ],
          },
          lockerInfo : {
            lockerCellId: '2023080700002', // 2023080700001, 2023080700002, 2023080700008, 2023080700009
            originId: '8', // 1, 8, 2, 9
          },
        },
        {
          receiveInfo : {
            status: '01',
            blNo: 'ET00000303',
            receiveScn: '09', // 해특
            shpcScn: '01', //DHL
            facility: '03',
            receiveNm: '손석희',
            area: '0301',
            receiveDept: '기업부설연구소',
            course: '',
            receiveEmail: '',
            executiveYn: 'N',
            receiveTel: '1533-4810',
            secretaryNm: null,
            receiveSabun: '66790619',
            secretaryEmail: null,
            sendNm: '이트너스',
            qty: Number('1'),
            receiveAreaScn: null,
            etcScn: '01',
            terrorSignScn: '01',
            contents: 'DEMO',
            lockerId: '00002', // DSR 무인보관함
            receiveEmailList: [
              "00@etners.com"
            ],
          },
          lockerInfo : {
            lockerCellId: '2023080700008', // 2023080700001, 2023080700002, 2023080700008, 2023080700009
            originId: '2', // 1, 8, 2, 9
          },
        },
        {
          receiveInfo : {
            status: '01',
            blNo: 'ET00000404',
            receiveScn: '01', // 등기
            shpcScn: '08', // 우체국
            facility: '03',
            receiveNm: '손석희',
            area: '0301',
            receiveDept: '기업부설연구소',
            course: '',
            receiveEmail: '',
            executiveYn: 'N',
            receiveTel: '1533-4810',
            secretaryNm: null,
            receiveSabun: '66790619',
            secretaryEmail: null,
            sendNm: '이트너스',
            qty: Number('1'),
            receiveAreaScn: null,
            etcScn: '01',
            terrorSignScn: '01',
            contents: 'DEMO',
            lockerId: '00002', // DSR 무인보관함
            receiveEmailList: [
              "00@etners.com"
            ],
          },
          lockerInfo : {
            lockerCellId: '2023080700009', // 2023080700001, 2023080700002, 2023080700008, 2023080700009
            originId: '9', // 1, 8, 2, 9
          },
        },
      ];
      await Promise.all(demoDataList.map(demoData => vm.demoReceiveSave(demoData))).then(() => {
        vm.commonOnChangeEvent()
        kendo.alert('시연용 데이터 정상 입력')
      }).catch((e) => kendo.alert(e))
    },
    // 키오스크 시연용 수령 등록
    demoReceiveSave(demoData){
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/receive/receiveSave.json`
      const formData = new FormData()
      const param = {
        loginUserToken: vm.loginUserToken,
        receiveInfo: demoData.receiveInfo,
        isSendMail: false,
      }
      formData.append('receiveSaveRequestParam', new Blob([JSON.stringify(param)],{
        type: 'application/json',
      }))
      return new Promise((resolve, reject) => {
        // 1. 수령
        ApiUtil.postIncludeUploadFile(url, formData).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            reject('정상적으로 처리되지 않았습니다.')
            return false
          }
          const resultStatus = response.data.resultStatus
          if (resultStatus.messageCode !== '2000') {
            reject(resultStatus.messageText)
            return false
          }
          const demoReceiveId = response.data.resultData
          const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/kiosk/locker/updateLockerCell.json`
          const param = {
            loginUserToken: vm.loginUserToken,
            userSabun: demoData.receiveInfo.userSabun,
            lockerId: demoData.receiveInfo.lockerId,
            lockerCellInfoList: [
              {
                lockerCellId: demoData.lockerInfo.lockerCellId,
                originId: demoData.lockerInfo.originId,
                cellStatus: '02',
                taskGbn: 'R',
                taskId: demoReceiveId
              },
            ],
            itemStatus: "03",
            userNm: "demo user"
          }
          // 2. 무인보관함 업데이트
          ApiUtil.post(url, param).then(response => {
            if (response.data === undefined || response.data.resultStatus === undefined) {
              reject('정상적으로 처리되지 않았습니다.')
              return false
            }
            if (response.data.resultStatus.messageCode !== '2000') {
              reject(response.data.resultStatus.messageText)
              return false
            }
            // 3. 수령 업데이트 + 메일 발송
            const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/kiosk/admin/adminReceiveUpdate.json`
            const param = {
              loginUserToken: vm.loginUserToken,
              receiveIdList: [demoReceiveId],
              kioskNo: '00002',
              lockerId: demoData.receiveInfo.lockerId,
            }
            ApiUtil.post(url, param).then(response => {
              if (response.data === undefined || response.data.resultStatus === undefined) {
                reject('정상적으로 처리되지 않았습니다.')
                return false
              }
              if (response.data.resultStatus.messageCode !== '2000') {
                reject(response.data.resultStatus.messageText)
                return false
              }
              resolve(true)
              return true
            })
          })
          return false
        }).catch(error => {
          reject(error)
        })
      })
    },

  },
  data () {
    const kendoGridHeaderAttributes = {
      style: 'font-weight: bold; text-align : center;'
    }
    const kendoGridBodyAttributes = {
      class: 'tcenter k-text-ellipsis',
    }
    const now = new Date()
    const vm = this
    const loginUserData = JSON.parse(sessionStorage.getItem('loginUserData'))
    const isSU = loginUserData.authId === '9999'
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      loginUserData: JSON.parse(sessionStorage.getItem('loginUserData')),
      isProd : process.env.NODE_ENV === 'production', // production, development, local
      isSU: isSU,
      lastRouteParams: {},
      lastRenderingTime: EtnersParseUtil.convertDateToStringYYYYMMDDHHMISSFormat(now),
      intervalSetting: undefined,
      autoRender: false,
      maxDate : now,
      userData: {
        receiveNm : null,
        receiveDept : null,
        receivePpsScn : null,
        receivePurpose : null,
        receivePurposeDesc : null,
      },
      receiveInfo: {},
      receiveDataSource : [],
      receiveListColumns : [
        {
          title: '전체선택',
          selectable: "true",
          width: "6%",
          attributes: {
            class: 'tcenter'
          },
        },
        {
          field: 'frstRgstDt',
          title: '등록일시',
          width: '12%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
        },
        {
          field: 'facilityNm',
          title: '사업장',
          width: '12%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: kendoGridBodyAttributes,
          template(dataItem) {
            return EtnersParseUtil.convertEmptyStringToSeparator(dataItem.facilityNm)
          }
        },
        {
          field: 'areaNm',
          title: '거점',
          width: '12%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: kendoGridBodyAttributes,
          template(dataItem) {
            return EtnersParseUtil.convertEmptyStringToSeparator(dataItem.areaNm)
          }
        },
        {
          field: 'shpcScnNm',
          title: '특송사',
          width: '8%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: kendoGridBodyAttributes,
        },
        {
          field: 'qty',
          title: '수량',
          width: '6%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: kendoGridBodyAttributes,
        },
          {
            field: 'receiveScnNm',
            title: '취급 구분',
            width: '10%',
            headerAttributes: kendoGridHeaderAttributes,
            attributes: kendoGridBodyAttributes,
            template(dataItem) {
              return EtnersParseUtil.convertEmptyStringToSeparator(dataItem.receiveScnNm)
            }
          },
        {
          field: 'blNo',
          title: '운송장 번호',
          width: '15%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: kendoGridBodyAttributes,
          template(dataItem) {
            return EtnersParseUtil.convertEmptyStringToSeparator(dataItem.blNo)
          }
        },
        {
          field: 'sendNm',
          title: '발신',
          width: '10%',
          headerAttributes : {
            'class': 'bg_green',
          },
          attributes: kendoGridBodyAttributes,
          template(dataItem) {
            return EtnersParseUtil.convertEmptyStringToSeparator(dataItem.sendNm)
          }
        },
        {
          field: 'receiveNm',
          title: '수신',
          width: '8%',
          headerAttributes : {
            'class': 'bg_blue',
          },
          attributes: kendoGridBodyAttributes,
          template(dataItem) {
            return EtnersParseUtil.convertEmptyStringToSeparator(dataItem.receiveNm)
          }
        },
        {
          field: 'receiveDept',
          title: '수신 부서',
          width: '12%',
          headerAttributes : {
            'class': 'bg_blue',
          },
          attributes: kendoGridBodyAttributes,
          template(dataItem) {
            return EtnersParseUtil.convertEmptyStringToSeparator(dataItem.receiveDept)
          }
        },
        {
          field: 'steadNm',
          title: '수령인',
          width: '12%',
          headerAttributes : {
            'class': 'bg_blue',
          },
          attributes: kendoGridBodyAttributes,
          template(dataItem) {
            let res = EtnersParseUtil.convertEmptyStringToSeparator(dataItem.steadNm)
            if (dataItem.steadYn === 'Y') {
              res = `<b>[대리]</b>${dataItem.steadNm} `
            }
            return res
          }
        },
        {
          field: 'terrorSignScnNm',
          title: '상태 여부',
          width: '8%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
        },
        {
          field: '',
          title: '수령',
          width: '16%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          command: [
            {
              name: '본인수령',
              template: `<a class="k-grid-본인수령"><button class="mid_btn orange" style="margin:-10px">본인 수령</button></a>`,
              click: function (e) {
                e.preventDefault()
                let tr = $(e.target).closest('tr')
                const selectedRow = this.dataItem(tr)
                if(!vm.isSU && selectedRow.facility !== vm.loginUserData.facility){
                  kendo.alert('소속된 사업장의 물품만 수정 가능합니다.')
                  return
                }
                vm.getReceiveDetail(selectedRow.receiveId).then(() => {
                  if (selectedRow.receiveScn === '09' && selectedRow.etcScn === '01'){
                    vm.$refs.createMyReceiveInterDocuWindowRef.$refs.kendoWindowRef.kendoWidget().center().open()
                  } else {
                    vm.myReceiveSave(vm.userData)
                  }
                })
              },
              visible (dataItem) {
                return ((dataItem.status === '01' || ( dataItem.status === '97' && dataItem.steadYn === null ) ) && dataItem.lockerYn === 'N')
              },
            },
            {
              name: '대리수령',
              template: `<a class="k-grid-대리수령"><button class="mid_btn orange" style="margin:-10px">대리 수령</button></a>`,
              click: function (e) {
                e.preventDefault()
                let tr = $(e.target).closest('tr')
                const selectedRow = this.dataItem(tr)
                if(!vm.isSU && selectedRow.facility !== vm.loginUserData.facility){
                  kendo.alert('소속된 사업장의 물품만 수정 가능합니다.')
                  return
                }
                vm.getReceiveDetail(selectedRow.receiveId).then(() => {
                  if (selectedRow.receiveScn === '09' && selectedRow.etcScn === '01') {
                    vm.$refs.createSteadReceiveInterDocuWindowRef.$refs.kendoWindowRef.kendoWidget().center().open()
                  } else {
                    vm.$refs.createSteadReceiveWindowRef.$refs.kendoWindowRef.kendoWidget().center().open()
                  }
                })
              },
              visible (dataItem) {
                return ((dataItem.status === '01'|| ( dataItem.status === '97' && dataItem.steadYn === null ) ) && dataItem.lockerYn === 'N')
              },
            },
            {
              name: '무인보관함보관',
              template:`<span name="lockerNm"></span><b class="mgl10">[ </span><span class="txt_b" name="lockerCellId"></span><span> ]</b></span>`,
              visible (dataItem) {
                return (dataItem.status === '01' && dataItem.lockerYn !== 'N' && !!dataItem.lockerCellId)
              },
            },
            {
              name: '무인보관함',
              template:`<span name="lockerNm"></span>`,
              visible (dataItem) {
                return (dataItem.status === '01' && dataItem.lockerYn !== 'N' && !!!dataItem.lockerCellId)
              },
            },
            // <b class="f_s">[수령 완료] </b>
            {
              name: '수령완료',
              template: `<span class="txt_s" name="receiveDt"></span>`,
              visible (dataItem) {
                return (dataItem.status === '99' || ( dataItem.status === '97' && dataItem.steadYn !== null ) )
              },
            },
            {
              name: 'empty',
              template: kendo.template(`<a class='k-grid-empty'>-</a>`),
              visible (dataItem) {
                return (dataItem.status !== '01' && dataItem.status !== '97' && dataItem.status !== '99')
              },
            },
          ]

        },
        {
          field: 'path',
          title: '접수 경로',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
        },
        {
          field: 'statusNm',
          title: '진행 상태',
          width: '12%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          template(dataItem) {
            let res = EtnersParseUtil.convertEmptyStringToSeparator(dataItem.statusNm)
            if (dataItem.status === '99') {
              return `<span class='process08 process_icon'>${res}</span>`
            }else if(dataItem.status === '01'){
              return `<span class='process02 process_icon'>${res}</span>`
            }else if(dataItem.status === '02'){
              return `<span class='process01 process_icon'>${res}</span>`
            }else if(dataItem.status === '97'){
              return `<span class='process03 process_icon'>${res}</span>`
            }else if(dataItem.status === '98'){
              return `<span class='process04 process_icon'>${res}</span>`
            }
          }
        },
      ],
    }
  },
}
</script>

<style scoped>

</style>
